const testimonials = [
  {
    name: "Jennifer K.",
    location: "Pensacola, FL",
    rating: 5,
    text: "I had a business trip to London in 6 days and realized my passport was expired. Fast Passport Center saved the day — got my renewal back in 5 days. Their team walked me through every step and even recommended the best UPS location in downtown Pensacola for overnight shipping.",
    service: "Passport Renewal",
  },
  {
    name: "David R.",
    location: "Gulf Breeze, FL",
    rating: 5,
    text: "My daughter needed a passport for a school trip to France. We live in Gulf Breeze and thought we'd have to drive to Atlanta. Nope — FPC handled everything. We shipped from the FedEx on Gulf Breeze Parkway and had her passport in 7 days. Incredible.",
    service: "Child Passport",
  },
  {
    name: "Sandra M.",
    location: "Navarre, FL",
    rating: 5,
    text: "My passport was lost during a move from Navarre to Pace. I panicked because I had a cruise leaving from Port Canaveral in 3 weeks. FPC guided me through the DS-64 process, helped me find the right clerk in Pensacola, and got my replacement in 8 days. Couldn't be happier.",
    service: "Lost Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function PensacolaTestimonialsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Pensacola Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Pensacola, Gulf Breeze, Navarre, and the western Panhandle who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}